// Display-only translation of the fixed animal types. Stored values, filters and payloads keep the original text;
// unknown types fall back to that original text.
const KEYS = { Beef: 'beef', Lamb: 'lamb', Sheep: 'sheep', Goat: 'goat' };

export function animalLabel(t, value) {
  const key = KEYS[value];
  return key ? t('animals.' + key) : value;
}

// Comma-separated lists such as "Beef, Goat" are translated one item at a time
export function animalListLabel(t, text) {
  return typeof text === 'string' ? text.split(', ').map((part) => animalLabel(t, part)).join(', ') : text;
}
